/**@jsx jsx */
import { ReactNode } from 'react'
import { jsx, ThemeProvider } from 'theme-ui'
import '../layout-base.css'
import { defaultTheme } from '../../theme'
import Header from './header'
import Footer from './footer'

type AffiliateLayoutProps = {
  children: ReactNode
  disclaimers?: JSX.Element[]
}

export const AffiliateLayout: React.FC<AffiliateLayoutProps> = ({
  children,
  disclaimers,
}) => {
  return (
    <ThemeProvider theme={{ ...defaultTheme, useCustomProperties: false }}>
      <Header />
      <main sx={{ backgroundColor: 'white' }}>{children}</main>
      <Footer disclaimers={disclaimers} />
    </ThemeProvider>
  )
}
